export default {
    Metadata: {
        Name: "Replace",
        Description: "Returns a base string replaced using a search string with a given replacement value.",
        Syntax: "Replace(string, find_string, replace_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(fullString, findString, replaceString) {
        if (fullString != null && findString != null) {

            if (typeof fullString != 'string')
                fullString = fullString.toString();

            //Ensure to escape all specials in the speciifed string to find...EK
            findString = findString.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");

            return fullString.replace(new RegExp(findString, "g"), replaceString);
        }
        else return fullString.toString();
    },
};

